import { render } from "./Payouts.vue?vue&type=template&id=f754a75e"
import script from "./Payouts.vue?vue&type=script&lang=js"
export * from "./Payouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__